<template>
    <div>
        <div
            v-for="(dialog, index) in dialogs"
            :key="index"
        >
            <v-dialog
                :persistent="persistent(index)"
                :value="true"
                :width="dialog.width"
                :content-class="fixed(index) ? 'fixed-dialog' : ''"
                :scrollable="scrollable(index)"
                @input="close"
            >
                <component
                    :is="dialog.component"
                    :dialog-index="index"
                />
            </v-dialog>
        </div>
    </div>
</template>
<script>
import { computed, watch } from "@vue/composition-api";
import DialogModule from "../../store/modules/dialog";

export default {
    name: "GenericDialog",
    setup() {
        const {
            dialog_component,
            dialog_width,
            dialogs,
            closeDialog
        } = DialogModule();

        const dialogOpen = computed(() => {
            return dialogs.value.length > 0 ? true : false;
        });
        function persistent(index) {
            return dialogs.value[index].payload.isPersistent;
        }

        function fixed(index) {
            return dialogs.value[index].payload.fixed;
        }

        function scrollable(index) {
            return dialogs.value[index].payload.scrollable;
        }

        const component = computed(() => {
            if (dialog_component.value) {
                return dialog_component.value;
            } else {
                return "";
            }
        });
        function close() {
            closeDialog();
        }
        return {
            dialog_width,
            dialogOpen,
            component,
            dialogs,
            close,
            persistent,
            scrollable,
            fixed
        };
    }
};
</script>
<style lang="scss">
.v-dialog.fixed-dialog {
    margin-bottom: auto;
    margin-top: 50px;
}
</style>